// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__109Mv","colMaxWidth":"Table_colMaxWidth__2Y_6A"};